import React, { useContext, useEffect } from 'react';
import { TokenContext } from '../Context/TokenContext';
import { Box, CircularProgress, Typography } from '@mui/material';

const ProtectedRoute = ({ children }) => {
    const { accessToken, isAuthenticated, isLoading, startOAuthFlow } = useContext(TokenContext);

    const isCallbackPage = window.location.pathname === '/authentication/callback';
    const needsOAuthFlow = !isLoading && !isAuthenticated && !accessToken && !isCallbackPage;

    // startOAuthFlow met à jour l'état de TokenProvider (setCookie) et navigue :
    // ça doit se produire en effet, jamais pendant le rendu de ProtectedRoute,
    // sinon React lève "Cannot update a component while rendering a different
    // component" et deux navigations (celle-ci + une éventuelle déconnexion en
    // cours) peuvent partir en concurrence et s'annuler l'une l'autre.
    useEffect(() => {
        if (needsOAuthFlow) {
            console.log('🔒 Utilisateur non authentifié, lancement du flux OAuth');
            startOAuthFlow();
        }
    }, [needsOAuthFlow, startOAuthFlow]);

    // Afficher le loading pendant le processus d'authentification
    if (isLoading || needsOAuthFlow) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: '100vh',
                    gap: 2
                }}
            >
                <CircularProgress size={60} sx={{ color: 'primary.main' }} />
                <Typography variant="h6" color="text.secondary">
                    Authentification en cours...
                </Typography>
            </Box>
        );
    }

    // Utilisateur authentifié, afficher le contenu
    return children;
};

export default ProtectedRoute;